import React, { useEffect, useRef } from 'react';
import MessageItem from './MessageItem';

function MessagePane({ messages, loading, error }) {
  const messagesEndRef = useRef(null); // For scrolling to bottom

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }

  useEffect(() => {
    scrollToBottom();
  }, [messages]); // Scroll to bottom every time messages update

  if (loading) {
    return <p>Loading messages...</p>;
  }

  if (error) {
    return <p className="error-message">Failed to load messages.</p>;
  }

  if (!messages || messages.length === 0) {
    return <p>No messages in this conversation yet, or select a conversation.</p>;
  }

  return (
    <div className="messages-list">
      {messages.map(msg => (
        <MessageItem key={msg._id} message={msg} />
      ))}
      <div ref={messagesEndRef} /> {/* Element to scroll to */}
    </div>
  );
}

export default MessagePane; 